<template>
    <Fragment>
        <LoadingApp
            :isLoading.sync="isLoading"
            :is_full_page="true"
        />
        <AppSummary
            title_summary="Meus endereços"
            :collapses="collapses"
            v-if="showDeliveryMethods"
        >
            <template #order-address-collapse>
                <template v-if="address.length">
                    <template v-for="(item, key) in address" >
                        <div
                            data-toggle="collapse"
                            :data-target="'#endereco'+item.id"
                            role="button"
                            aria-expanded="false"
                            :aria-controls="'endereco'+item.id"
                            :key="key"
                            :class="['radio-group', mainAddress && item.id == mainAddress.id ? 'radio-group-active' : null]"
                        >
                            <div class="radio-heading">
                                <span class="radio-conteiner" @click.prevent.stop="changeMainAddress(item.id)">
                                    <input
                                        type="radio"
                                        :value="item"
                                        @click.prevent.stop="changeMainAddress(item.id)"
                                        :checked="mainAddress && item.id == mainAddress.id"
                                        :id="'address'+key+1"
                                    >
                                </span>
                                <span class="forma-conteiner" style="font-size:12px">
                                    <span style="float:left">{{item.name_address ? item.name_address : item.city}}</span>
                                    <span v-if="user.data.user_type == 'F'" style="float:right">
                                        <a href="#" @click.prevent="showEditAddress(item.id)" class="btn btn-sm btn-link">
                                            Editar
                                        </a>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div
                            class="collapse"
                            :id="'endereco'+item.id"
                            :key="item.id+120"
                            :class="['content-payment',  mainAddress && item.id == mainAddress.id ?  'content-payment-active show' : null]">
                            <address style="font-size: 12px;">
                                <strong>Nome do endereço: </strong>{{item.name_address}} <br>
                                <strong>Destinatário: </strong>{{item.receiver}} <br>
                                <strong>Rua: </strong>{{item.address}}, {{item.number}} <br>
                                <strong>Bairro: </strong>{{item.district}} <br>
                                <strong>CEP: </strong>{{item.postal_code}} <br>
                                <strong>Cidade: </strong>{{item.city}} <br>
                                <strong>UF: </strong>{{item.uf}} <br>
                                <strong>Telefone: </strong>{{item.phone}}<br>
                            </address>
                        </div>
                    </template>
                </template>
                <div v-if="user.data.user_type == 'F'"
                    class="radio-group"
                    @click.prevent.stop="showModal(), action_form = 'create'"
                >
                    <div class="radio-heading">
                        <span class="radio-conteiner">
                            <input
                                type="radio"
                                :value="null"
                                @click.prevent.stop="showModal(), action_form = 'create'"
                                id="addressnew"
                            >
                        </span>
                        <span class="forma-conteiner" style="font-size:12px">
                            + Novo endereço
                        </span>
                    </div>
                </div>
            </template>
        </AppSummary>


        <div class="modal fade" id="modalAddress"  aria-labelledby="modalAddress" aria-hidden="true">
            <div class="modal-dialog">
                <form
                    @submit.prevent="submit"
                    method="post"
                    style="max-width: 100%;"
                >
                    <modal-content class="modal-content" id="content-address">
                        <div class="modal-header">
                            <c-heading-4 v-if="action_form == 'create'" class="modal-title">Novo endereço</c-heading-4>
                            <c-heading-4 v-else class="modal-title">Editar endereço</c-heading-4>
                            <button type="button" class="close" @click.prevent="$root.closeModalApp('modalAddress')">&times;</button>
                        </div>
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <c-form-group class="form-group">
                                        <label for="name_address">Identificar este endereço como:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.name_address"
                                            id="name_address"
                                            name="name_address"
                                        />
                                    </c-form-group>
                                </div>
                                <div class="col-md-6">
                                    <c-form-group class="form-group required-field">
                                        <label for="receiver">
                                            Destinatário:
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.receiver"
                                            id="receiver"
                                            name="receiver"
                                        />
                                        <div v-if="submited && !$v.form.receiver.required" class="required">* Destinatário obrigatório</div>
                                    </c-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <c-form-group class="form-group required-field">
                                        <label for="postal_code">CEP:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.postal_code"
                                            @change="consultaCep(form.postal_code)"
                                            id="postal_code"
                                            v-mask="'#####-###'"
                                            name="postal_code"
                                        />
                                        <div v-if="submited && !$v.form.postal_code.required" class="required">* CEP obrigatório</div>
                                    </c-form-group>
                                </div>
                                <div class="col-md-7">
                                    <c-form-group class="form-group required-field">
                                        <label for="city">
                                            Cidade:
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control disabled"
                                            v-model="form.city"
                                            id="city"
                                            name="city"
                                            readonly
                                        />
                                        <div v-if="submited && !$v.form.city.required" class="required">* Cidade obrigatório</div>
                                    </c-form-group>
                                </div>
                                <div class="col-md-2">
                                    <c-form-group class="form-group required-field">
                                        <label for="uf">
                                            UF:
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control disabled"
                                            v-model="form.uf"
                                            id="uf"
                                            name="uf"
                                            readonly
                                        />
                                        <div v-if="submited && !$v.form.uf.required" class="required">* UF obrigatório</div>
                                    </c-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <c-form-group class="form-group required-field">
                                        <label for="address">Rua:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.address"
                                            id="address"
                                            name="address"
                                        />
                                        <div v-if="submited && !$v.form.address.required" class="required">* Rua obrigatório</div>
                                    </c-form-group>
                                </div>
                                <div class="col-md-2">
                                    <c-form-group class="form-group required-field">
                                        <label for="number">Número:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.number"
                                            id="number"
                                            name="number"
                                        />
                                        <div v-if="submited && !$v.form.number.required" class="required">* Número obrigatório</div>
                                    </c-form-group>
                                </div>
                                <div class="col-md-5">
                                    <c-form-group class="form-group required-field">
                                        <label for="complement">Complemento:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.complement"
                                            id="complement"
                                            name="complement"
                                        />
                                    </c-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <c-form-group class="form-group required-field">
                                        <label for="district">Bairro:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.district"
                                            id="district"
                                            name="district"
                                        />
                                    </c-form-group>
                                </div>
                                <div class="col-md-5">
                                    <c-form-group class="form-group required-field">
                                        <label for="phone">Telefone:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.phone"
                                            v-mask="'(##) #####-####'"
                                            id="phone"
                                            name="phone"
                                        />
                                        <div v-if="submited && !$v.form.phone.required" class="required">* Telefone obrigatório</div>
                                    </c-form-group>
                                </div>
                                <div class="col-md-7">
                                    <c-form-group class="form-group required-field">
                                        <label for="reference_location">Referência de localização:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.reference_location"
                                            id="reference_location"
                                            name="reference_location"
                                        />
                                    </c-form-group>
                                </div>
                            </div>
                            <div v-if="action_form != 'update'" class="row">
                                <div class="col-md-4">
                                    <c-form-group class="form-group">
                                        <input type="checkbox" id="main" v-model="form.main"  name="main">
                                        <label for="main">Definir como endereço principal</label><br/>
                                    </c-form-group>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer space-between">
                            <c-button
                                backgroundColor="#dc3545"
                                backgroundColorHover="#bd2130"
                                color="#fff"
                                colorHover="#fff"
                                :textTransform="$root.$children[0].theme.products.button.text_transform"
                                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                                borderColor="transparent"
                                borderColorHover="transparent"
                                type="button"
                                data-dismiss="modal"
                                margin="0px 3rem 0px 0px"
                                height="unset"
                                minWidth="124px"
                                padding="1rem 2rem"
                                display="inline-block"
                                textAlign="center"
                                lineHeight="1.5"
                                letterSpacing=".1rem"
                                transition="all .3s"
                            >
                                Cancelar
                            </c-button>
                            <c-button
                                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                                :color="$root.$children[0].theme.products.button.color"
                                :colorHover="$root.$children[0].theme.products.button.color_hover"
                                :borderColor="$root.$children[0].theme.products.button.border_color"
                                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                                type="submit"
                                margin="0px 3rem 0px 0px"
                                :textTransform="$root.$children[0].theme.products.button.text_transform"
                                height="unset"
                                minWidth="124px"
                                padding="1rem 2rem"
                                display="inline-block"
                                textAlign="center"
                                lineHeight="1.5"
                                letterSpacing=".1rem"
                                transition="all .3s"
                            >
                                Salvar
                            </c-button>
                        </div>
                    </modal-content>
                 </form>
            </div>
        </div>
    </Fragment>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ConsultaCep from '../../api/consultaCep'
import { mapState, mapActions, mapGetters } from 'vuex'
import LoadingApp from '../LoadingApp'
import { Fragment }  from 'vue-fragment'
import AppSummary from '../AppSummary'
import { CButton } from '../Styles/Button/styled'
import { CFormGroup, CHeading4 } from '../Styles/Components/styled'
import { CModalContent } from '../Styles/Template/styled'
import { swall } from '../../services/sweetAlert'

export default {
    name: 'StepAddress',
    components: {
        LoadingApp,
        Fragment,
        AppSummary,
        'c-button': CButton,
        'c-heading-4': CHeading4,
        'c-form-group': CFormGroup,
        'modal-content': CModalContent
    },
    props:{
        user: {default: null}
    },
    data() {
        return {
            isLoading: false,
            form: {
                name_address: null,
                receiver: null,
                postal_code: null,
                city: null,
                uf:null,
                address: null,
                district:null,
                complement:null,
                number:null,
                reference_location:null,
                main: false,
                phone: null,
                ibge: null
            },
            address_id: null,
            submited:false,
            action_form: 'create',
            collapses: [
                {
                    title: "Escolha seu endereço de entrega",
                    id: "order-address-collapse",
                    collapsed: true
                },
            ]
        }
    },
    validations: {
        form: {
            postal_code: { required },
            city: { required },
            uf: { required },
            address: { required },
            district: { required },
            number: { required },
            receiver: { required },
            phone: { required }
        }
    },
    async created() {
        await this.ActionGetCepDestination();
        await this.getAllAddressApp()
        await this.checkShippingMethod();
        if(this.address[0].postal_code == null) {
            await this.showEditAddress(this.address[0].id)
        }
    },
    methods: {
        ...mapActions('address', [
            "ActionSetAddress",
            "ActionGetAllAddress",
            "ActionGetAddress",
            "ActionCreate",
            "ActionUpdateAddress",
            "ActionSetMain",
            "ActionGetMainAddress",
            "ActionSetMainAddress"
        ]),
        ...mapActions("shipping", [
            "ActionSetShippings",
            "ActionGetAllShippingCalculation",
            "ActionSetShippingMethodState",
            "ActionGetCepDestination",
            "ActionDestroySessionShippingMethod"
        ]),
        ...mapActions("cart", [
            "ActionSetItemsCart",
            "ActionGetItemsCart"
        ]),
        async checkShippingMethod() {
            if (!this.cepDestination) {
                return;
            }
            let postal_code_main = this.address.find(a => a.main)?.postal_code?.replace('-', '');
            let postal_code_destination = this.cepDestination.replace('-', '');
            if (postal_code_main != postal_code_destination) {
                this.isLoading = true;
                this.ActionSetShippingMethodState(null);
                await this.ActionDestroySessionShippingMethod();
                await this.getItemsCart();
                this.isLoading = false;
            }
        },
        async getShippingCalculation() {
            await this.ActionGetAllShippingCalculation()
        },
        async getItemsCart() {
            await this.ActionGetItemsCart()
            .then((resp) => {
                let { data } = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                if(error.msg) {
                    console.log('ERROR GET ITEMS CART: '+error.msg)
                    return
                }
                console.log('ERROR GET ITEMS CART: '+error)
            })
        },
        showModal() {
            this.resetForm()
            this.$root.showModalApp('modalAddress')
        },
        async showEditAddress(address_id) {
            this.action_form = 'update'
            this.resetForm()
            this.address_id = address_id
            await this.ActionGetAddress(address_id)
            .then((resp) => {
                let { data } = resp
                this.form.name_address = data.name_address
                this.form.receiver = data.receiver
                this.form.postal_code = data.postal_code
                this.form.city = data.city
                this.form.uf = data.uf
                this.form.address = data.address
                this.form.district = data.district
                this.form.complement = data.complement
                this.form.number = data.number
                this.form.reference_location = data.reference_location
                this.form.main = data.main
                this.form.phone = data.phone
                this.form.ibge = data.ibge
                this.$root.showModalApp('modalAddress')
            })
            .catch((error) => {
                swall(error?.msg ?? error?.message ?? error, true);
            })
        },
        async submit() {
            this.showLoading()
            this.submited = true
            if (this.$v.$invalid) {
                this.hideLoading()
                this.$v.form.$touch()
                return
            }
            if(this.action_form === 'create') {
                await this.createAddress()
            } else {
                await this.editAddress()
            }
            this.hideLoading()
        },
        async editAddress() {
            let data = {
                ...this.form,
                address_id: this.address_id
            }
            this.$emit('address-updated', data);
            await this.ActionUpdateAddress(data)
            .then(async (response) => {
                let {error, msg, validator=null} = response
                if(error === true) {
                    swall(msg, true);
                    return
                }
                this.action_form = 'create'
                this.$v.$reset()

                await this.getShippingCalculation()
                await this.getAllAddressApp()
                await this.changeMainAddressState()
                this.$root.closeModalApp('modalAddress')
                this.resetForm()
                swall("Endereço alterado com sucesso!", false, "check", "success");
            })
            .catch((error) => {
                alert(error.msg)
            })
        },
        async createAddress() {
            await this.ActionCreate(this.form)
            .then(async (response) => {
                this.$emit('address-updated', this.form);
                let {error, msg, validator=null} = response
                this.$v.$reset()
                await this.getShippingCalculation()
                await this.getAllAddressApp()
                await this.changeMainAddressState()
                await this.getItemsCart()
                this.$root.closeModalApp('modalAddress')
                this.resetForm()
                swall("Endereço cadastrado com sucesso!", false, "check", "success");
            })
            .catch((error) => {
                swall(error?.msg ?? error?.message ?? error, true);
            })
        },
        async changeMainAddressState() {
            try {
                const response = await this.ActionGetMainAddress()
                this.ActionSetMainAddress(response.data)
                .then(() => {
                    this.ActionSetShippingMethodState(null)
                })

            } catch(error) {
                swall(error?.msg ?? error?.message ?? error, true);
            }
        },
        checkMain(main) {
            if(main === false) {
                this.form.main = true
                return
            }
            this.form.main = false
        },
        async getAllAddressApp() {
            try {
                const response = await this.ActionGetAllAddress()
                this.ActionSetAddress(response.data)
            } catch(error) {
                swall(error?.msg ?? error?.message ?? error, true);
            }
        },
        async changeMainAddress(address_id) {
            this.isLoading = true
            await this.ActionSetMain({address_id: address_id})
            .then(async (response) => {
                let {error, msg, validator=null} = response
                if(error === true) {
                    this.isLoading = false
                    swall(msg, true);
                }
                await this.getShippingCalculation()
                await this.getAllAddressApp()
                await this.changeMainAddressState()
                await this.getItemsCart()
                this.isLoading = false
                swall("Endereço alterado com sucesso!", false, "check", "success");
            })
            .catch((error) => {
                this.isLoading = false
                swall(error?.msg ?? error?.message ?? error, true);
            })
        },
        async consultaCep(cep_consulta) {
            if(cep_consulta == "") {
                return
            }

            try {
                let {
                    erro=null,
                    bairro=null,
                    cep=null,
                    complemento=null,
                    gia=null,
                    ibge=null,
                    localidade=null,
                    logradouro=null,
                    uf=null,
                    unidade=null

                } = await ConsultaCep.get(cep_consulta)
                if(erro) {
                    swall("CEP inválido!", true);
                    return
                }
                    this.form.city = localidade.toUpperCase()
                    this.form.uf = uf.toUpperCase()
                    this.form.district = bairro.toUpperCase()
                    this.form.address = logradouro.toUpperCase()
                    this.form.complement = complemento
                    this.form.ibge = ibge
            } catch(error) {
                swall(error?.msg ?? error?.message ?? error, true);
            }
        },
        resetForm() {
            this.address_id = null
            this.submited = false
            this.form.name_address = null
            this.form.postal_code = null
            this.form.city = null
            this.form.uf = null
            this.form.address = null
            this.form.district = null
            this.form.complement = null
            this.form.number = null
            this.form.reference_location = null
            this.form.receiver = null
            this.form.phone = null
            this.form.main = false

        },
        showLoading() {
            jQuery('#content-address').append("<div class='ajax-overlay' id='porto-loading-address' ><i class='porto-loading-icon'></i></div>");
        },
        hideLoading() {
            jQuery('#porto-loading-address').remove();
        }
    },
    computed: {
        ...mapState('address', [
            'address',
            'mainAddress'
        ]),
        ...mapState("shipping", ["cepDestination"]),
        ...mapGetters('company', ["showDeliveryMethods"]),
    }
}
</script>

<style scoped>
.inputIsentoChecked {
    background-color: #EDE56A;
}
.modal-header{
    height: 55px;
}
.shipping-address-box.active .main-address {
    visibility:visible;
}
.radio-group-active {
    background: rgba(0,0,0,0.04);
}
.content-payment {
    border-left: 1px solid rgb(221, 221, 221);
    padding: 10px;
    border-right: 1px solid rgb(221, 221, 221);
    margin-bottom: 5px;
    border-bottom: 1px solid rgb(221, 221, 221);
    border-radius: 4px;
    margin-top: -5px;
}
.content-payment-active {
    border-left: 1px solid rgb(221, 221, 221);
    padding: 10px;
    background: rgba(0, 0, 0, 0.04);
    border-right: 1px solid rgb(221, 221, 221);
    margin-bottom: 5px;
    border-bottom: 1px solid rgb(221, 221, 221);
    border-radius: 4px;
    margin-top: -5px;
}
</style>
